import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoxRegularReportIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M10.3 9.6q0-.5.5-.6h.4q.5 0 .6.6v4q0 .6-.6.7h-.4l-.6-.6zM8 11.8q0-.5.6-.5h.3q.5 0 .6.5v1.9q0 .5-.6.6h-.3l-.6-.6zm5-2h.4q.5 0 .6.5v3.4q0 .5-.6.6h-.3l-.6-.6v-3.4q0-.5.6-.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m8.3 12.7 1.2-.7v1.3l-.7.4-.7.3-.1-.3v-1.9q0-.3.3-.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6.7 1.8q1-.6 2 0l3.8 2q1 .6 1 1.7v3.3h-.9l-.2-.3V6l-4 2v2.2q-.9.1-1.2.8V8l-4-2.2v4q0 .6.4.8l3.4 2v1.3l-.3-.2-3.6-2A2 2 0 0 1 2 10V5.5q0-1 1-1.7zm-3.1 3 4.2 2.3 1.4-.8-4-2.3H5zm4.6-2a1 1 0 0 0-1 0l-1 .5 4.2 2.3 1.5-.8z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m11.8 12.1-1.6.8v-1.3l1.6-.8zm1.6-2.3a2 2 0 0 1-1 1.8v-1.4q0-.5.6-.5z"
		})
	]
});
export default SvgBoxRegularReportIcon;
